import MenuBox from './Components/MenuBox'

import useViewModel from './ViewModel'
import RolePermissionConfigs from 'Configuration/RolePermission'

const ShortCutView: React.FC = () => {
  const { roleId, checkPermission } = useViewModel()
  const isDemo = process.env.REACT_APP_PACO_VERSION === 'DEMO'

  return (
    <>
      {!isDemo && (
        <>
          {checkPermission(
            [
              ...RolePermissionConfigs.dashboard_overview,
              ...RolePermissionConfigs.dashboard_operation,
            ],
            roleId
          ) && (
            <div className='row'>
              <div className='col-12'>
                <div className='fs-2 fw-bold'>การจัดการโครงการ</div>

                <div
                  className='separator mt-3 mb-7'
                  style={{ borderWidth: 2, borderColor: '#e0e0e0' }}></div>
              </div>
            </div>
          )}

          <div className='row'>
            {RolePermissionConfigs.dashboard_overview.includes(roleId) && (
              <div className='col-12 col-lg-4 mb-5'>
                <MenuBox
                  title='ภาพรวมผู้บริหาร'
                  path='/dashboard/overview'
                  icon={'/media/icons/duotune/graphs/gra001.svg'}
                />
              </div>
            )}

            {RolePermissionConfigs.dashboard_operation.includes(roleId) && (
              <div className='col-12 col-lg-4 mb-5'>
                <MenuBox
                  title='ภาพรวมฝ่ายปฎิบัติการ'
                  path='/dashboard/operation'
                  icon={'/media/icons/duotune/layouts/lay001.svg'}
                />
              </div>
            )}
          </div>
        </>
      )}

      <div className='row'>
        {RolePermissionConfigs.sale_order.includes(roleId) && (
          <div className='col-12 col-lg-4 mb-5'>
            <MenuBox
              title='ใบสั่งขาย'
              path='/sale-order'
              icon={'/media/icons/duotune/finance/fin010.svg'}
            />
          </div>
        )}

        {RolePermissionConfigs.survey.includes(roleId) && (
          <div className='col-12 col-lg-4 mb-5'>
            <MenuBox
              title='การสำรวจ'
              path='/survey'
              icon={'/media/icons/duotune/files/fil024.svg'}
            />
          </div>
        )}

        {!isDemo && RolePermissionConfigs.project.includes(roleId) && (
          <div className='col-12 col-lg-4 mb-5'>
            <MenuBox
              title='โครงการ'
              path='/project'
              icon={'/media/icons/duotune/general/gen005.svg'}
            />
          </div>
        )}
      </div>

      {!isDemo && checkPermission([...RolePermissionConfigs.machine], roleId) && (
        <>
          <div className='row'>
            <div className='col-12'>
              <div className='fs-2 fw-bold'>ข้อมูลตั้งต้น</div>

              <div
                className='separator mt-3 mb-7'
                style={{ borderWidth: 2, borderColor: '#e0e0e0' }}></div>
            </div>
          </div>
        </>
      )}

      <div className='row'>
        {RolePermissionConfigs.machine.includes(roleId) && (
          <div className='col-12 col-lg-4 mb-5'>
            <MenuBox
              title='เครื่องจักร'
              path='/machine'
              icon='/media/icons/duotune/technology/teh005.svg'
              color='warning'
            />
          </div>
        )}

        {RolePermissionConfigs.machine.includes(roleId) && (
          <div className='col-12 col-lg-4 mb-5'>
            <MenuBox
              title='เสาเข็ม'
              path='/pile'
              icon='/media/icons/duotune/technology/teh010.svg'
              color='warning'
            />
          </div>
        )}
      </div>

      {!isDemo && (
        <>
          {checkPermission(
            [
              ...RolePermissionConfigs.shipping_request,
              ...RolePermissionConfigs.request,
              ...RolePermissionConfigs.maintenance,
            ],
            roleId
          ) && (
            <div className='row'>
              <div className='col-12'>
                <div className='fs-2 fw-bold'>รายงาน</div>

                <div
                  className='separator mt-3 mb-7'
                  style={{ borderWidth: 2, borderColor: '#e0e0e0' }}></div>
              </div>
            </div>
          )}

          <div className='row'>
            {RolePermissionConfigs.shipping_request.includes(roleId) && (
              <div className='col-12 col-lg-4 mb-5'>
                <MenuBox
                  title='คำขอการขนส่ง'
                  path='/shipping-request'
                  icon={'/media/icons/duotune/ecommerce/ecm006.svg'}
                  color='info'
                />
              </div>
            )}

            {RolePermissionConfigs.maintenance.includes(roleId) && (
              <div className='col-12 col-lg-4 mb-5'>
                <MenuBox
                  title='แจ้งหยุดงาน'
                  path='/maintenance'
                  icon={'/media/icons/duotune/coding/cod001.svg'}
                  color='info'
                />
              </div>
            )}

            {RolePermissionConfigs.request.includes(roleId) && (
              <div className='col-12 col-lg-4 mb-5'>
                <MenuBox
                  title='คำร้องขอ'
                  path='/request'
                  icon={'/media/icons/duotune/files/fil005.svg'}
                  color='info'
                />
              </div>
            )}
          </div>
        </>
      )}

      {checkPermission([...RolePermissionConfigs.user], roleId) && (
        <div className='row'>
          <div className='col-12'>
            <div className='fs-2 fw-bold'>ตั้งค่า</div>

            <div
              className='separator mt-3 mb-7'
              style={{ borderWidth: 2, borderColor: '#e0e0e0' }}></div>
          </div>
        </div>
      )}

      <div className='row'>
        {RolePermissionConfigs.user.includes(roleId) && (
          <div className='col-12 col-lg-4 mb-5'>
            <MenuBox
              title='จัดการผู้ใช้งาน'
              icon={'/media/icons/duotune/general/gen049.svg'}
              path='/users'
              color='success'
            />
          </div>
        )}

        <div className='col-12'>
          <div
            className='separator mt-3 mb-7'
            style={{ borderWidth: 2, borderColor: '#e0e0e0' }}></div>
        </div>

        <div className='col-12 col-lg-4 mb-5'>
          <MenuBox
            title='ลงชื่อออก'
            icon={'/media/icons/duotune/arrows/arr015.svg'}
            path='/sign-out'
            color='secondary'
            textColor='grey'
          />
        </div>
      </div>
    </>
  )
}

export default ShortCutView
